"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSlate = void 0;
const lodash_get_1 = __importDefault(require("lodash.get"));
exports.mapSlate = (rawInstructions, d, defaultF = () => null) => lodash_get_1.default(rawInstructions, "document.nodes", []).map((b) => {
    const text = lodash_get_1.default(b, "nodes[0].text", "");
    if (!("type" in b)) {
        return null;
    }
    if (b.type in d) {
        return d[b.type](text);
    }
    return defaultF(text);
});
//# sourceMappingURL=mapSlate.js.map